/**
 * The models a persona can answer in the feedback room with — an internal
 * switch, for the team to compare them on real sessions before one is picked
 * for launch. Only admins can choose; everyone else gets the default.
 *
 * The default is `DEFAULT_PERSONA_CHAT_MODEL` below. Every id here needs a row
 * in the API's price table (`credits/pricing.ts`), or its rounds are charged
 * at the default's rate.
 */
export const PERSONA_CHAT_MODELS = [
  { id: 'gemini-3-flash-preview', label: '3 Flash' },
  { id: 'gemini-3.7-flash', label: '3.7 Flash' },
  { id: 'gemini-3.8-flash', label: '3.8 Flash' },
] as const;

export type PersonaChatModel = (typeof PERSONA_CHAT_MODELS)[number]['id'];

/** What personas answer with unless an admin picks otherwise. 3.8 Flash for
 *  V1. */
export const DEFAULT_PERSONA_CHAT_MODEL: PersonaChatModel = 'gemini-3.8-flash';

export const PERSONA_CHAT_MODEL_IDS: PersonaChatModel[] =
  PERSONA_CHAT_MODELS.map((model) => model.id);

/** A model's short label, or the id itself for one no longer on the list. */
export function personaChatModelLabel(id: string): string {
  return PERSONA_CHAT_MODELS.find((model) => model.id === id)?.label ?? id;
}
